// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"ry-z","modalContent":"sy-z","header":"ty-z","close":"uy-z"};